import { Form, Input, Modal, Space, notification, Select } from 'antd';
import CustomButton from 'components/custom-button';
import { REQUIRED } from 'constants/rule-form';
import { useEffect, useState } from 'react';
import { API } from 'service/api-route';
import AxiosUtils from 'utils/axios-utils';
import styles from '../styles.module.scss';
import { CHECK_FILE } from 'utils/rule-form';
import CustomizedUpload from 'components/customized-upload';
import { TYPE_BANNER, TYPE_MENU, UPLOAD_TYPE } from 'constants/common';
import { SERVER_FILE_ENDPOINT } from 'constants/envs';
import { BannerPreview, BannerSizeNote } from './BannerSizeGuide';
const { Option } = Select;
interface DataPost {
  name?: string;
  link?: string;
  image: any;
  type: string;
}

interface Props {
  isOpen: boolean;
  handleCancelCreateEditModal: () => void;
  onChangeStatusUpdateData: () => void;
  valueUserSelected: any;
}

const ModalCreateEdit = ({
  isOpen,
  valueUserSelected,
  handleCancelCreateEditModal,
  onChangeStatusUpdateData,
}: Props) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const image: { fileUrl?: string } | null | undefined = Form.useWatch('image', form);

  const onFinish = async (values: DataPost) => {
    values.image = values?.image?.fileKey;
    values.type = values?.type.toString();
    setLoading(true);
    if (valueUserSelected?.id) {
      try {
        const res: any = await AxiosUtils.patch(
          `${API.updateBanners}/${valueUserSelected?.id}`,
          values
        );
        if (res?.status === 200) {
          handleCancelCreateEditModal();
          onChangeStatusUpdateData();
          notification.success({
            message: 'Thành công',
            description: 'Sửa thành công!',
            duration: 4,
          });
        }
      } catch (error) {
        notification.error({
          message: 'Không thành công',
          description: 'Có lỗi xảy ra, vui lòng thử lại.',
          duration: 4,
        });
      } finally {
        setLoading(false);
      }
    } else {
      try {
        const res: any = await AxiosUtils.post(API.updateBanners, values);
        if (res?.status === 201) {
          handleCancelCreateEditModal();
          onChangeStatusUpdateData();
          notification.success({
            message: 'Thành công',
            description: 'Tạo thành công!',
            duration: 4,
          });
        }
      } catch (error) {
        notification.error({
          message: 'Không thành công',
          description: 'Có lỗi xảy ra, vui lòng thử lại.',
          duration: 4,
        });
      } finally {
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    form.setFieldsValue({
      name: valueUserSelected?.name || '',
      link: valueUserSelected?.link || '',
      type: valueUserSelected?.type.split(','),
      image: valueUserSelected?.image
        ? {
            fileKey: valueUserSelected?.image,
            fileUrl: `${SERVER_FILE_ENDPOINT}/${valueUserSelected.image}`,
          }
        : null,
    });
  }, [form, valueUserSelected]);

  return (
    <>
      <Modal
        forceRender
        open={isOpen}
        title={valueUserSelected?.id ? 'Sửa banner' : 'Thêm banner'}
        onCancel={handleCancelCreateEditModal}
        width={800}
        getContainer={false}
        footer={false}
      >
        <Form
          name="form"
          form={form}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          onFinish={onFinish}
          autoComplete="off"
        >
          <label className={styles.labelInput} htmlFor="name">
            Tên
          </label>
          <Form.Item
            name="name"
            rules={[
              {
                max: 200,
                message: 'Không được quá 200 kí tự',
              },
            ]}
            wrapperCol={{ span: 24 }}
          >
            <Input placeholder="Nhập tên" size="large" />
          </Form.Item>

          <label className={styles.labelInput} htmlFor="link">
            Liên kết khi bấm vào
          </label>
          <Form.Item name="link" rules={[]} wrapperCol={{ span: 24 }}>
            <Input placeholder="Nhập link" size="large" />
          </Form.Item>
          <label className={styles.labelInput} htmlFor="type">
            Hiển thị banner ở đâu?
          </label>
          <Form.Item rules={[REQUIRED]} name="type" wrapperCol={{ span: 24 }}>
            <Select mode="multiple" placeholder="Chọn nơi hiển thị banner" size="large">
              <Option value={TYPE_BANNER.HOME}>Trang chủ</Option>
              <Option value={TYPE_BANNER.LIVE_SHOW}>Liveshow</Option>
              <Option value={TYPE_BANNER.PK}>PK</Option>
            </Select>
          </Form.Item>

          <label className={styles.labelInput} htmlFor="image">
            Ảnh
          </label>
          <BannerSizeNote />
          <Form.Item name="image" wrapperCol={{ span: 24 }} rules={[CHECK_FILE]}>
            <CustomizedUpload type={UPLOAD_TYPE.IMAGE} maxFileSize={5} />
          </Form.Item>
          <BannerPreview src={image?.fileUrl || undefined} />

          <div className="d-flex justify-center">
            <Space size="large">
              <CustomButton
                bgColor="secondary-green"
                text="Lưu"
                htmlType="submit"
                loading={loading}
              />
              <CustomButton
                text="Hủy"
                bgColor="primary-grey"
                htmlType="button"
                onClick={handleCancelCreateEditModal}
              />
            </Space>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default ModalCreateEdit;
